import React from 'react';

const StoryboardConverterPreview = ({ config }) => {
  const parseStoryboard = () => {
    if (!config.storyboardContent) {
      return { hasContent: false, viewCount: 0, buttonCount: 0, labelCount: 0 };
    }

    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(config.storyboardContent, 'text/xml');
      
      const views = xmlDoc.getElementsByTagName('view');
      const buttons = xmlDoc.getElementsByTagName('button');
      const labels = xmlDoc.getElementsByTagName('label');
      const imageViews = xmlDoc.getElementsByTagName('imageView');
      const textFields = xmlDoc.getElementsByTagName('textField');
      const textViews = xmlDoc.getElementsByTagName('textView');

      return {
        hasContent: true,
        viewCount: views.length,
        buttonCount: buttons.length,
        labelCount: labels.length,
        imageViewCount: imageViews.length,
        textFieldCount: textFields.length,
        textViewCount: textViews.length,
      };
    } catch (e) {
      return { hasContent: true, error: e.message };
    }
  };

  const stats = parseStoryboard();

  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-900 p-8">
      <div className="max-w-2xl w-full bg-gray-800 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Storyboard Analysis</h3>
        
        {!stats.hasContent ? (
          <div className="text-gray-500 text-center py-8">
            Upload or paste a storyboard file to see analysis
          </div>
        ) : stats.error ? (
          <div className="text-red-400 text-center py-8">
            Error parsing XML: {stats.error}
          </div>
        ) : (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.viewCount}</div>
                <div className="text-sm text-gray-400">Views</div>
              </div>
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.buttonCount}</div>
                <div className="text-sm text-gray-400">Buttons</div>
              </div>
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.labelCount}</div>
                <div className="text-sm text-gray-400">Labels</div>
              </div>
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.imageViewCount}</div>
                <div className="text-sm text-gray-400">Image Views</div>
              </div>
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.textFieldCount}</div>
                <div className="text-sm text-gray-400">Text Fields</div>
              </div>
              <div className="bg-gray-900 rounded p-4">
                <div className="text-2xl font-bold text-primary-600">{stats.textViewCount}</div>
                <div className="text-sm text-gray-400">Text Views</div>
              </div>
            </div>
            
            <div className="mt-4 text-xs text-gray-500">
              These components will be converted to SwiftUI equivalents in the generated code.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoryboardConverterPreview;

